import buildMeta from '@/router/utils/buildMeta'

const routes = [
  {
    name: 'resume-scan',
    path: '/opportunity/:opportunityId/scan', // TBD
    component: () => import('@/pages/ResumeScan/ResumeScan.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Resume Scan',
      title: 'Resume Scan - Jobscan',
      liveChatEnabled: true,
    }),
  },
]

export default routes
